import React from "react";

export const Badge = ({ texto }) => <span className='badge m-1 px-2' style={{ background: 'var(--ws-blue)', color: 'black', fontWeight: '300' }}>{texto}</span>;